/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Mutation } from '@apollo/client/react/components';
import { useQuery } from '@apollo/client';
import Form from '../components/form';
import {
  EDIT_BRAND,
  GET_BRAND_BY_ID,
} from '../../../../queries/products/brand';

const BrandById = (brandId) => {
  const res = useQuery(GET_BRAND_BY_ID, {
    variables: { id: brandId },
    fetchPolicy: 'network-only',
  });
  return res;
};

export const Update = ({ id, refetchList, onCloseDrawer }) => {
  const { data, loading, error } = BrandById(id);

  if (loading) return <>Loading...</>;
  if (error) return <>{`Error! ${error.message}`}</>;

  return (
    <Mutation
      mutation={EDIT_BRAND}
      update={async () => {
        await refetchList();
        onCloseDrawer();
      }}
    >
      {(updatebrands) => <Form query_f={updatebrands} {...data?.brand} />}
    </Mutation>
  );
};
